<template lang="pug">
div
  visualizar-cadastro-coletivo(
    :cadastro="cadastroColetivo"
    :showInformacoesAnalise="false"
    :isRetificacao="isRetificacao"
  )
  div.wrap-collabsible(v-if="oficiosExists")
    divider(label="Documentos Tramitados")
    table-generica(
      :dados="documentosAssinados"
      :colunas="colunas"
      :botoesAcao="botoesAcao"
      )
  div.wrap-collabsible(v-if="despachosFormatados.length && !isRetificacao")
    divider(label="Histórico de despachos")
    el-collapse
      el-collapse-item(v-for="despacho in despachosFormatados" :key="despacho.dataCriacao" :title="`Análise ${setoresFormatado[despacho.setor]}`" :name="despacho.dataCriacao")
        Informacoes-analise(
          :responsavel="despacho.usuario.pessoa.nomeRazaoSocial"
          :cargo="despacho.perfil"
          :data="despacho.dataCriacao"
        )
        div
          divider(label="Despacho")
          div.mt-1.padding-info-analise
          el-row
            p.input(v-html="despacho.texto")
        div(v-if="despacho.documento")
          divider(label="Anexo")
          div.arquivos(v-if="despacho.documento")
            app-download-arquivo(
              :arquivo="despacho.documento"
              @download="download(despacho.documento)"
            )

</template>

<script>
import InformacoesAnalise from '@/screens/arrecadacao/components/InformacoesAnalise'
import Divider from '@/screens/arrecadacao/components/Divider'
import AppDownloadArquivo from '@/components/AppDownloadArquivo'
import VisualizarCadastroColetivo from '@/screens/arrecadacao/components/VisualizarCadastroColetivo'
import { mapActions, mapGetters } from 'vuex'
import FileHelper from '@/utils/fileHelper'
import TableGenerica from '@/components/TableGenerica'

const { setoresFormatado } = require('@/utils/' + process.env.ESTADO + '/setor').default

export default {
  components: {
    InformacoesAnalise,
    AppDownloadArquivo,
    Divider,
    VisualizarCadastroColetivo,
    TableGenerica
  },

  props: {
    despachos: { required: true, type: Array },
    documentosAssinados: { required: false, type: Array },
    cadastroColetivo: { required: true, type: Object },
    isRetificacao: {default: false}
  },

  data () {
    return {
      despachosFormatados: [],
      setoresFormatado,
      colunas: [
        {
          prop: 'numeroOficio',
          label: 'Nº Documento',
          formatter: this.formataNumeroOficio
        },
        {
          prop: 'tipo.nome',
          label: 'Tipo de Documento',
          formatter: this.formataOficio
        },
        {
          prop: 'cartorio.nome',
          label: 'Destinatário',
          formatter: this.formataDestinatario
        }
      ]
    }
  },

  computed: {
    ...mapGetters({
      usuarioLogado: 'auth/usuarioLogado'
    }),

    oficiosExists () {
      return this.documentosAssinados && this.documentosAssinados.length
    }
  },

  methods: {
    ...mapActions({
      downloadDocumentos: 'documentoArrecadacao/download',
      getPDFMatricula: 'oficioArrecadacao/getPDFMatricula',
      getPDFCertidaoNegativa: 'oficioArrecadacao/getPDFCertidaoNegativa',
      getPDFPortaria: 'portariaArrecadacao/getPDFPortariaAssinado'
    }),

    async download (documento) {
      let bytes
      switch (documento.tipo?.codigo) {
        case 'CERTIDAO_NEGATIVA':
          bytes = await this.getPDFCertidaoNegativa(documento.id)
          break
        case 'MATRICULA':
          bytes = await this.getPDFCertidaoNegativa(documento.id)
          break
        default:
          if (documento.numeroPortaria) {
            bytes = await this.getPDFPortaria(documento.id)
          } else {
            bytes = await this.downloadDocumentos({
              fileKey: documento.fileKey,
              id: documento.id
            })
          }
          break
      }

      FileHelper.saveFile(
        bytes,
        documento.nomeOriginal || documento.nomeArquivo
      )
    },

    formataDespachos () {
      this.despachosFormatados = this.$props.despachos.map(despacho => {
        if (despacho.documento) {
          return {
            ...despacho,
            documento: {
              ...despacho.documento,
              nome: despacho.documento.nomeOriginal
            }
          }
        } else {
          return despacho
        }
      })
    },

    formataDestinatario (oficio) {
      if (oficio.cartorio?.nome) {
        return `${oficio.cartorio.nome} - ${oficio.cartorio.municipio.nomeComCodigoEstadoFormatado}`
      }
      return 'Gabinete'
    },

    formataNumeroOficio (oficio) {
      return oficio.numeroOficio || oficio.numeroPortaria
    },

    formataOficio (oficio) {
      if (oficio.tipo?.codigo) {
        return `Ofício de ${oficio.tipo.nome}`
      }
      return 'Portaria'
    },

    botoesAcao (oficio) {
      const acoes = [
        {
          click: this.download.bind(this, oficio),
          icon: 'get_app',
          title: 'Download Ofício',
          active: true
        }
      ]

      if (!oficio.numeroPortaria && oficio.hasConversa) {
        acoes.push({
          click: this.goToConversa.bind(this, oficio),
          icon: 'chat',
          title: 'Visualizar conversa',
          active: true
        })
      }

      return acoes
    },

    goToConversa (oficio) {
      if (this.usuarioLogado.moduloSelecionado.codigo === 'ANALISE') {
        this.$router.push({
          name: 'analise/cartorio/conversa',
          query: {
            protocolo: oficio.protocolo,
            idProcesso: this.$route.query.idProcesso
          }
        })
      } else {
        this.$router.push({
          name: 'cartorio/conversa',
          query: {
            protocolo: oficio.protocolo,
            idProcesso: this.$route.query.idProcesso
          }
        })
      }
    }
  },

  watch: {
    despachos: {
      async handler () {
        if (this.despachos.length) {
          this.formataDespachos()
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/element-variables.scss';
>>> .el-collapse-item__header {
  font-size: 17px;
}

.wrap-collabsible {
  margin-bottom: 1.2rem 0;
}

input[type='checkbox'] {
  display: none;
}

.lbl-toggle {
  display: block;

  font-weight: bold;
  font-size: 17px;
  font-weight: 500;
  color: #303133;

  cursor: pointer;

  border-radius: 7px;
  transition: all 0.3s ease-out;

  height: 48px;
  line-height: 48px;
  label {
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    cursor: pointer;
  }
}

.icon {
  transition: transform 0.3s ease-out;
}

.toggle:checked + .lbl-toggle {
  i {
    transform: rotate(90deg) translateX(-3px);
  }
}

.collapsible-content {
  max-height: 0px;
  overflow: hidden;
  transition: max-height 0.3s;
}

.toggle:checked + .lbl-toggle + .collapsible-content {
  max-height: 200vh;
  padding-bottom: 25px;
}

.toggle:checked + .lbl-toggle {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.label {
  font-weight: 600;
  margin-left: 10px;
  font-size: 16px;
}

.ml-2 {
  margin-left: 12px;
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/components/Despachos.vue